import store from "store";
import { userToken,userKey, REGISTER_KEY,Index_Fresh_Info,Current_Order_KEY } from "../config";

export const storageInfo = {

  saveToken: (userObj) => {
    store.set(userToken, userObj);
  },

  //获取存储在本地的token
  getToken: () => {
    return store.get(userToken);
  },

  //保存用户信息
  saveUserInfo: (userObj) => {
    if(userObj) {
      store.set(userKey, userObj);
    }
    else {
      store.remove(userKey);
      store.remove(userToken);
    }
  },
  //获取存储在本地的用户信息
  getUserInfo: () => {
    return store.get(userKey);
  },

  //删除本地存储的用户信息
  delUserInfo: () => {
    store.remove(userKey);
  },

  //保存注册信息
  saveRegisterInfo: (userObj) => {
    store.set(REGISTER_KEY, userObj);
  },
  //获取存储在本地的注册信息
  getRegisterInfo: () => {
    return store.get(REGISTER_KEY);
  },

  //删除本地存储的注册信息
  delRegisterInfo: () => {
    store.remove(REGISTER_KEY);
  },

  //保存首页推荐用户信息
  saveIndexFreshInfo: (userObj) => {
    store.set(Index_Fresh_Info, userObj);
  },
  //获取存储在本地的首页推荐用户
  getIndexFreshInfo: () => {
    return store.get(Index_Fresh_Info);
  },

  //保存最新订单
  saveCurrentOrder: (userObj) => {
    store.set(Current_Order_KEY, userObj);
  },
  //获取最新订单
  getCurrentOrder: () => {
    return store.get(Current_Order_KEY);
  },
};
